import { Button, Image } from '@chakra-ui/react'
import { toast } from 'sonner'
import React from 'react'
import { useRouter } from 'next/navigation'
import { useUser } from '@/src/store/user-store'

import {
  useSubscribeChannelMutation,
  useUnsubscribeChannelMutation,
} from '@/src/mutations/video/subscribe'

import { useQueryClient } from '@tanstack/react-query'
import { usePostHogEvents, EVENTS } from '@/lib/posthog-events'

export const SubscribeBtn = ({
  isSubscribed,
  eventId,
  channelId,
  invalidateKey,
  isDisabled,
}: {
  isSubscribed: boolean
  eventId: string
  channelId: string
  invalidateKey: string
  isDisabled?: boolean
}) => {
  const queryClient = useQueryClient()
  const subscribeChannelMutation = useSubscribeChannelMutation()
  const unsubscribeChannelMutation = useUnsubscribeChannelMutation()
  const { trackEvent } = usePostHogEvents()

  const { user } = useUser()
  const router = useRouter()
  function handleSubscribe() {
    if (!user) {
      toast.error('You need to Log in to subscribe', {
        action: {
          label: 'Login',
          onClick: () => {
            router.push('/auth/login')
          },
        },
      })
      return
    } else if (isSubscribed) {
      unsubscribeChannelMutation.mutate(
        {
          channelId,
          eventId,
        },
        {
          onSuccess: () => {
            toast.success('Unsubscribed to the channel')
            trackEvent(EVENTS.CREATOR_UNSUBSCRIBED, { channel_id: channelId, event_id: eventId })
          },
          onError: () => {
            toast.error('Failed to unsubscribe to the channel')
          },
          onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [invalidateKey] })
          },
        }
      )
    } else if (!isSubscribed) {
      subscribeChannelMutation.mutate(
        {
          channelId,
          eventId,
        },
        {
          onSuccess: () => {
            toast.success('Subscribed to the channel')
            trackEvent(EVENTS.CREATOR_SUBSCRIBED, { channel_id: channelId, event_id: eventId })
          },
          onError: () => {
            toast.error('Failed to subscribe to the channel')
          },
          onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [invalidateKey] })
          },
        }
      )
    }
  }

  return (
    <>
      <Button
        _hover={{ opacity: 0.6 }}
        rounded={'full'}
        bg={isSubscribed ? '#ECECEC' : 'lyk-green'}
        color={isSubscribed ? '#333' : 'white'}
        fontSize={14}
        leftIcon={
          isSubscribed ? (
            <Image src="/video/bell.svg" alt="Bell" boxSize={5} />
          ) : (
            <></>
          )
        }
        rightIcon={
          isSubscribed ? (
            <Image src="/video/chevron-down.svg" alt="Bell" boxSize={5} />
          ) : (
            <></>
          )
        }
        onClick={handleSubscribe}
        isLoading={
          isSubscribed
            ? unsubscribeChannelMutation.isPending
            : subscribeChannelMutation.isPending
        }
        isDisabled={isDisabled ? isDisabled : false}
        width={['auto']}
      >
        {isSubscribed ? 'Subscribed' : 'Subscribe'}
      </Button>
    </>
  )
}
